/**
 * Incremental SSE frame parser. Returns the unconsumed tail of the buffer.
 * Comment-only frames (`: ping`) are ignored; `data:` lines are joined and passed to onData.
 */
export function consumeSseBuffer(buffer: string, onData: (json: string) => void): string {
  const parts = buffer.split('\n\n');
  const rest = parts.pop() ?? '';
  for (const block of parts) {
    const dataLines: string[] = [];
    for (const rawLine of block.split('\n')) {
      const line = rawLine.replace(/\r$/, '');
      if (line.startsWith(':')) continue;
      if (line.startsWith('data:')) {
        dataLines.push(line.slice(5).replace(/^\s/, ''));
      }
    }
    if (dataLines.length > 0) {
      onData(dataLines.join('\n'));
    }
  }
  return rest;
}
